import Modal from '@components/modal/Modal';
import useEditPassword from './hooks/useEditPassword';
import Form from '@components/form/Form';
import FormRow from 'lib/src/components/form/FormRow';
import TextInput from '@components/form/TextInput';
import usePasswordValidation from 'lib/src/hooks/usePasswordValidation';

const EditPasswordModal: React.FC<EditPasswordModalProps> = ({ closeModal }) => {
    const {
        formState: { currentPassword, password, confirmPassword },
        isPosting,
        postError,
        handleChange,
        handleSubmit,
    } = useEditPassword(closeModal);

    const { validatePassword, validateConfirmPassword } = usePasswordValidation(password);

    return (
        <Modal title="Edit password" size="small" closeModal={closeModal}>
            <Form
                onCancel={closeModal}
                onSubmit={handleSubmit}
                isPosting={isPosting}
                error={postError}
            >
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="currentPassword"
                        value={currentPassword}
                        onChange={handleChange}
                        label="Current Password"
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="password"
                        value={password}
                        onChange={handleChange}
                        label="New Password"
                        customValidate={validatePassword}
                    />
                </FormRow>
                <FormRow>
                    <TextInput
                        required
                        type="password"
                        name="confirmPassword"
                        value={confirmPassword}
                        onChange={handleChange}
                        customValidate={validateConfirmPassword}
                        label="Confirm Password"
                    />
                </FormRow>
            </Form>
        </Modal>
    );
};

interface EditPasswordModalProps {
    closeModal: () => void;
}

export default EditPasswordModal;
